import { createFileRoute } from "@tanstack/react-router";
import { LegalPage } from "@/components/landing/LegalPage";

export const Route = createFileRoute("/legal/aydinlatma-metni")({
  head: () => ({
    meta: [
      { title: "Уведомление об обработке данных — TurkeyDrive" },
      { name: "description", content: "KVKK Aydınlatma Metni / Уведомление об обработке персональных данных TurkeyDrive." },
      { property: "og:title", content: "Уведомление об обработке данных — TurkeyDrive" },
      { property: "og:description", content: "KVKK Aydınlatma Metni / Уведомление об обработке персональных данных TurkeyDrive." },
      { property: "og:type", content: "article" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: () => <LegalPage slug="aydinlatma-metni" />,
});
